// extracted by mini-css-extract-plugin
module.exports = {"text":"ScheduleValidator_text__lvKv6","classesList":"ScheduleValidator_classesList__t-pzh"};